import { IconButton, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShowDrawer } from '../../../shared';
import MenuIcon from '@mui/icons-material/Menu';

export const AppTitle: FC = () => {
    const navigate = useNavigate();
    const { showDrawer, setShowDrawer, hasDrawer } = useShowDrawer();
    const { logo } = window.carity.environment.theme;

    return (
        <Stack
            direction="row"
            id="app-title"
            justifyContent="space-between"
            sx={{ justifyContent: 'flex-start', width: 'fit-content' }}
        >
            <img src={logo} style={{ cursor: 'pointer' }} alt="Carity" onClick={() => navigate('')} />
            <Typography variant="h1" sx={{ width: 'fit-content', pr: 0 }}>
                carity<strong>support</strong>
            </Typography>
            {hasDrawer && (
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={() => setShowDrawer(!showDrawer)}
                    sx={{
                        px: 2,
                        display: { xs: 'inline-flex', lg: 'none' },
                        flex: 1,
                        ml: 'auto',
                        maxWidth: 'fit-content',
                    }}
                >
                    <MenuIcon />
                </IconButton>
            )}
        </Stack>
    );
};
